import { linkToAlertDetail } from "#src/Routers/links";
import { EventContext } from "#src/contexts/EventContext";
import {
  DataTable,
  HeaderType,
  ItemAction,
  Pill,
} from "@validereinc/common-components";
import { EventAdapter } from "@validereinc/domain";
import React, { useContext, useMemo } from "react";
import { RoutingLink } from "../RoutingLink";

type EventAlertType = {
  id: string;
  monitor?: { name?: string };
  inserted_at: string;
  resolved: boolean;
  condition_descriptions?: string[];
};

export const EventAlertsTable = () => {
  const { event, isLoading, onRefetchEvent } = useContext(EventContext) || {};

  const onRemove = async ({ alertId }: { alertId?: string }) => {
    if (!event?.id || !alertId) return;
    await EventAdapter.alerts.deleteOne({ alertId, eventId: event?.id });
    onRefetchEvent?.();
  };

  const headers: Array<HeaderType<EventAlertType>> = useMemo(
    () => [
      {
        key: "monitor.name",
        label: "Name",
        renderComponent: ({ item }) => (
          <RoutingLink to={linkToAlertDetail(item.id)}>
            {item.monitor?.name}
          </RoutingLink>
        ),
      },
      {
        key: "inserted_at",
        label: "Date Triggered",
        renderComponent: ({ item }) => (
          <DataTable.DataRow.DateCell
            value={item.inserted_at}
            withTime
          />
        ),
      },
      {
        key: "resolved",
        label: `Status`,
        renderComponent: ({ item }) => (
          <Pill variant={item.resolved ? "default" : "error"}>
            {item.resolved ? "Closed" : "Open"}
          </Pill>
        ),
      },
      {
        key: "condition_descriptions",
        label: "Alert Condition Satisfied",
        renderComponent: ({ item }) => item.condition_descriptions?.join(", "),
      },
    ],
    []
  );

  return (
    <DataTable
      headers={headers}
      items={event?.alerts?.data ?? []}
      isLoading={isLoading}
      getItemId={(item) => item.id}
      getItemActions={({ item: { id } }): ItemAction[] => [
        {
          label: "Remove",
          buttonProps: {
            onClick: () => {
              onRemove({ alertId: id });
            },
            icon: "trash",
          },
        },
      ]}
    />
  );
};
